module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-layer-search-topo",
      "title": "Ricerche sui Livelli"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ae8cbc0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/LayerSearchTopo.vue
// module id = 860
// module chunks = 39